export default __webpack_public_path__ + "static/media/mars31.515d6908.gif";